import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=4a8cf49e&scoped=true"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&id=4a8cf49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8cf49e",
  null
  
)

export default component.exports